// @flow

export default function toJson (maybeObject: ?Object | ?string): ?string {
  if (maybeObject) {
    try {
      if (typeof maybeObject === 'object') {
        return JSON.stringify(maybeObject)
      } else if (typeof maybeObject === 'string') {
        return maybeObject
      }
    } finally {}
  }

  return null
}
